  <div *ngIf="isShownWebModal==true"
    id="AssotnVerifyModal"
    class="modal fade upgrade-fade"
    tabindex="-1" role="dialog"
    [config]="{ show: true, backdrop: 'static' }"
    (onHidden)="onHidden()"
    bsModal
    #autoShownModal="bs-modal"
    style="z-index: 1111;">
      <!-- *ngIf="displayObj?.display_section!='share'" -->
    <div *ngIf="displayObj?.display_section=='verify_step1'"
      class="custom-theme-modal modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body  p-0">
          <app-country-and-association-modal>
          </app-country-and-association-modal>
        </div>
      </div>
    </div>
    <div *ngIf="displayObj?.display_section=='verify_step2'"
      class="custom-theme-modal modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div  class="modal-body  p-0">
          <app-association-verification-modal
            [data]="displayObj?.data">
          </app-association-verification-modal>
        </div>
      </div>
    </div>
    <div *ngIf="displayObj?.display_section=='verificationSuccess'"
      class="custom-theme-modal modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body p-4">
          <app-verification-success-modal
            [data]="displayObj?.data">
          </app-verification-success-modal>
        </div>
      </div>
    </div>
    <div *ngIf="displayObj?.display_section=='infoModal'"
      class="custom-theme-modal modal-dialog modal-md modal-dialog-centered">

      <div class="modal-content">
        <div class="modal-header">
          <span class="cursor-pointer" data-dismiss="modal" aria-label="Close" (click)="hideModal()">

            <svg version="1.1" width="10px" viewBox="0 0 191.414 191.414" enable-background="new 0 0 191.414 191.414"
              class="close-detail">
              <g>
                <path
                  d="M107.888,96.142l80.916-80.916c3.48-3.48,3.48-8.701,0-12.181s-8.701-3.48-12.181,0L95.707,83.961L14.791,3.045   c-3.48-3.48-8.701-3.48-12.181,0s-3.48,8.701,0,12.181l80.915,80.916L2.61,177.057c-3.48,3.48-3.48,8.701,0,12.181   c1.74,1.74,5.22,1.74,6.96,1.74s5.22,0,5.22-1.74l80.916-80.916l80.916,80.916c1.74,1.74,5.22,1.74,6.96,1.74   c1.74,0,5.22,0,5.22-1.74c3.48-3.48,3.48-8.701,0-12.181L107.888,96.142z">
                </path>
              </g>
            </svg>
          </span>
        </div>
        <div class="modal-body p-4">
          <app-info [data]="displayObj?.errObj"></app-info>
        </div>
      </div>
    </div>
    <div *ngIf="displayObj?.display_section=='successModal'"
      class="custom-theme-modal modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body p-4">
          <app-success
            [data]="displayObj?.data">
          </app-success>
        </div>
      </div>
    </div>

    <div *ngIf="displayObj?.display_section=='cmeDesc'"
      class="custom-theme-modal modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <app-cme-desc
            [data]="displayObj">
          </app-cme-desc>
        </div>
      </div>
    </div>

    <div *ngIf="displayObj?.display_section=='user_not_verified'"
      class="custom-theme-modal modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body  p-4">
          <app-user-not-verified
            [data]="displayObj?.data">
          </app-user-not-verified>
        </div>
      </div>
    </div>

    <div *ngIf="displayObj?.display_section=='cmeDetail'"
      class="custom-theme-modal modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <app-web-cme-detail-modal
          [courseId]="displayObj.data[0].data"
          [callon]="'modal'">
        </app-web-cme-detail-modal>
      </div>
    </div>

    <div *ngIf="displayObj?.display_section == 'showtnc'"
      class="custom-theme-modal modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content p-2">
        <app-product-tnc
          [data]="displayObj?.data">
        </app-product-tnc>
      </div>
    </div>

    <div *ngIf="displayObj?.display_section=='showEventMediaModal'"
      class="custom-theme-modal modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <app-event-medial-list
          [data]="displayObj">
        </app-event-medial-list>
      </div>
    </div>

    <div *ngIf="displayObj?.display_section=='showEventSessionModal'"
      class="custom-theme-modal modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <app-event-session-modal class="h-100"
          [data]="displayObj">
        </app-event-session-modal>
      </div>
    </div>

    <div *ngIf="displayObj?.display_section=='showEventCertificateList'"
      class="custom-theme-modal modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <app-event-session-certificate-list
          [data]="displayObj">
        </app-event-session-certificate-list>
      </div>
    </div>

    <div *ngIf="displayObj?.display_section=='showSpeakerListModal'">
      <app-event-speaker-list
        *ngIf="displayObj != undefined"
        [data]="displayObj" >
      </app-event-speaker-list>
    </div>

    <div *ngIf="displayObj?.display_section=='showDrugForm'"
      class="custom-theme-modal modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <app-drug-order-form
          *ngIf="displayObj !=undefined"
          [data]="displayObj">
        </app-drug-order-form>
      </div>
    </div>

    <div *ngIf="displayObj?.display_section=='reportForm'"
      class=" custom-theme-modal modal-dialog modal-md modal-dialog-centered">

      <div class="modal-content">
        <div class="modal-header p-0">
          <span class="cursor-pointer p-3 float-right" (click)='hideModal()'>
              <img src="assets/themes/icons/cancel.svg" alt="cross icon">
            </span>
        </div>

          <app-product-report *ngIf="displayObj !=undefined" [product_type]="displayObj?.data[0]?.product_type"
            [product_type_id]="displayObj?.data[0]?.product_type_id"></app-product-report>
      </div>
    </div>



    <div *ngIf="displayObj?.display_section=='eventShareModal'"
      class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <svg (click)="fcs.closeWebModal()"  class="position-absolute cursor-pointer" style="right:15px; top:15px" viewBox="0 0 20 20" width="15px"><defs ><style >.cross-post{fill:none;stroke:#3e3e3d;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}</style></defs><g  data-name="Layer 3" id="Layer_3"><line  class="cross-post" x1="2" x2="18" y1="2" y2="18"></line><line  class="cross-post" x1="18" x2="2" y1="2" y2="18"></line></g></svg>
          <app-event-share
            *ngIf="displayObj !=undefined"
            [data]="displayObj">
          </app-event-share>
        </div>
      </div>
    </div>

    <app-product-share 
      *ngIf="displayObj?.display_section=='share'" 
      [data]="displayObj?.data"
      [optionalData]="displayObj?.share_content">
    </app-product-share>

    <div *ngIf="displayObj?.display_section=='updatedModal2.0'"
      class="custom-theme-modal modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Reminder set successfully</h3>
          <svg class="close-detail" version="1.1" width="10px" viewBox="0 0 191.414 191.414" enable-background="new 0 0 191.414 191.414">
            <g>
              <path d="M107.888,96.142l80.916-80.916c3.48-3.48,3.48-8.701,0-12.181s-8.701-3.48-12.181,0L95.707,83.961L14.791,3.045   c-3.48-3.48-8.701-3.48-12.181,0s-3.48,8.701,0,12.181l80.915,80.916L2.61,177.057c-3.48,3.48-3.48,8.701,0,12.181   c1.74,1.74,5.22,1.74,6.96,1.74s5.22,0,5.22-1.74l80.916-80.916l80.916,80.916c1.74,1.74,5.22,1.74,6.96,1.74   c1.74,0,5.22,0,5.22-1.74c3.48-3.48,3.48-8.701,0-12.181L107.888,96.142z"/>
            </g>
          </svg>
        </div>
        <div class="modal-body">
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
        </div>
        <div class="modal-footer">
          <button class="btn-design medium filled">Action</button>
        </div>
      </div>
    </div>
  </div>
